const PHOTON_URL = "https://photon.komoot.io/api/";

function formatPhotonFeature(feature) {
  const p = feature.properties || {};
  const coords = (feature.geometry && feature.geometry.coordinates) || [];
  const street =
    p.street ||
    (p.osm_key === "highway" ? p.name : "") ||
    "";
  const houseNo = p.housenumber || "";
  const city = p.city || p.town || p.village || p.locality || "";
  const postCode = p.postcode || "";
  const country = p.country || "";
  const name = p.name || "";

  const line1 = [street || name, houseNo].filter(Boolean).join(" ").trim();
  const line2 = [postCode, city].filter(Boolean).join(" ").trim();
  const description = [line1, line2, country].filter(Boolean).join(", ");

  return {
    description,
    street: street || name,
    houseNo,
    city,
    postCode,
    country,
    lat: coords.length > 1 ? coords[1] : "",
    long: coords.length > 0 ? coords[0] : "",
  };
}

/**
 * Address typeahead via Photon (OpenStreetMap). Replaces Google Places so
 * suggestions work without a Maps JS key / billing account.
 */
export async function fetchAddressSuggestions(
  query,
  { signal, cityOnly = false, lang = "de", limit = 8 } = {}
) {
  if (!query || query.trim().length < 2) return [];

  const params = new URLSearchParams({
    q: query.trim(),
    limit: String(limit),
    lang,
    lat: "51.1657",
    lon: "10.4515",
  });
  if (cityOnly) {
    params.append("osm_tag", "place:city");
    params.append("osm_tag", "place:town");
    params.append("osm_tag", "place:village");
  }

  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 8000);
  if (signal) {
    if (signal.aborted) controller.abort();
    else signal.addEventListener("abort", () => controller.abort(), { once: true });
  }

  try {
    const res = await fetch(`${PHOTON_URL}?${params.toString()}`, {
      signal: controller.signal,
    });
    if (!res.ok) return [];
    const json = await res.json();
    const seen = new Set();
    return (json.features || [])
      .map(formatPhotonFeature)
      .filter((item) => {
        if (!item.description || seen.has(item.description)) return false;
        seen.add(item.description);
        return true;
      });
  } catch (e) {
    if (e.name === "AbortError") throw e;
    return [];
  } finally {
    clearTimeout(timeout);
  }
}
